import React from 'react';
import { connect } from "react-redux";
import { Router, Route, browserHistory, IndexRoute, applyRouterMiddleware, IndexRedirect } from 'react-router';
import {useScroll} from 'react-router-scroll';
import Intro from "../containers/Introduction";
import Admin from "../containers/Admin";
import AdminHomepage from '../containers/AdminHomepage';
import CategoryAdmin from '../components/CategoryAdmin';
import OptionsAdmin from '../components/OptionsAdmin';
import QuestionsAdmin from '../components/QuestionsAdmin';
import QuestionForm from '../components/QuestionForm';
import AdminQuestionList from '../containers/AdminQuestionList';
import AdminOptionList from '../containers/AdminOptionList';
import OptionForm from '../components/OptionForm';
import CategoryList from '../containers/CategoryList';
import CategoryForm from '../components/CategoryForm';
import Questionnaire from '../components/Questionnaire'; //bjs capitalized to match file name
import Section from '../components/Section';
import SectionIntro from '../containers/SectionIntro';
import QuestionPage from '../containers/QuestionPage';
import Results from '../containers/Results';
import ReferenceOptionsList from '../containers/ReferenceOptionsList';
import AnswersList from '../containers/AnswersList';
import UserHomepageContainer from '../containers/UserHomepageContainer';
import Landing from '../components/Landing';
import TagsAdmin from '../components/TagsAdmin';
import TagsList from '../containers/TagsList';
import App from '../containers/App';
import QuestionSortOrder from '../containers/QuestionSortOrder';
import ResultsReview from '../containers/ResultsReview';
import AdminExports from '../containers/AdminExports';
import TrAdminHomepage from '../containers/TrAdminHomepage';
import TrQuestionForm from './TrQuestionForm';
import TrAdmin from '../containers/TrAdmin';
import TrCategories from './TrCategories';
import { BackgroundSyncUIContextProvider } from '../hooks/useBackgroundSync';
import ReactGA from 'react-ga';
import {IntlProvider} from 'react-intl';
import {getResponse} from '../reducer/response';
import { history } from "../index";
import {getTranslationMessages} from "../reducer/translations"
import HarvestStrategyContatiner from "../containers/HarvestStrategyContainer"

require('es6-promise').polyfill();

const onRouterUpdate = (e, b) => {
  if (/admin/.test(window.location.pathname)) {
    document.documentElement.className = "admin";
  } else {
    document.documentElement.className = "";
  }
}

//Provider lifted up to index as it is needed to be wrapper for Routes to allow it to use connect

const Routes = (props) => (
  <BackgroundSyncUIContextProvider>
    <IntlProvider locale="en" defaultLocale="en" messages={getTranslationMessages(props.trIDForResponse)} key={props.trIDForResponse}>
      <Router history={history} onUpdate={onRouterUpdate} render={applyRouterMiddleware(useScroll())}>
      <Route path="/" component={App}>
        <Route path="resultsReview/:id/:section/:stage" component={ResultsReview} />
          <IndexRedirect to="/Questionnaire" />
          <Route path="Questionnaire" component={Questionnaire}>
            <IndexRoute component={Intro} />
            <Route path="landing/:id/:secret" component={Landing} />
            <Route path="reference/harvestStrategy" component={HarvestStrategyContatiner} />
            <Route path="reference/:section" component={ReferenceOptionsList} />
            <Route path="results/:id/answers" component={AnswersList} />
            <Route path="results/:id/harvestStrategy" component={HarvestStrategyContatiner} />
            <Route path="results/:id(/:section)" component={Results} />
            <Route path=":id/:section" component={Section}>
              <IndexRoute component={SectionIntro} />
              <Route path=":question" component={QuestionPage} />
            </Route>
            <Route path=":id/finish/:section" component={Section}>
              <IndexRoute component={SectionIntro} />
              <Route path=":question" isFinishing={true} component={QuestionPage} />
            </Route>
          </Route>
          <Route path="home(/:id)" component={UserHomepageContainer} />

          <Route path="/admin" component={Admin}>
            <IndexRoute component={AdminHomepage} />
            <Route path="options" component={OptionsAdmin}>
              <IndexRoute component={AdminOptionList} />
              <Route path="edit/:id" component={OptionForm} />
              <Route path="create" component={OptionForm} />
              <Route path=":section" component={AdminOptionList} />
            </Route>
            <Route path="questions" component={QuestionsAdmin}>
              <IndexRoute component={AdminQuestionList} />
              <Route path="create" component={QuestionForm} />
              <Route path=":id" component={QuestionForm} />
            </Route>
            <Route path="questionOrder" component={QuestionSortOrder} />
            <Route path="categories" component={CategoryAdmin}>
              <IndexRoute component={CategoryList} />
              <Route path=":id" component={CategoryForm} />
              <Route path="create" component={CategoryForm} />
              <Route path="create/:type" component={CategoryForm} />
            </Route>
            <Route path="tags" component={TagsAdmin}>
              <IndexRoute component={TagsList} />
            </Route>
            <Route path="exports" component={AdminExports} />
            <Route path="translation" component={TrAdmin}>
              <IndexRoute component={TrAdminHomepage} />
                <Route path=":trID/questions" component={QuestionsAdmin}>
                  <IndexRoute component={AdminQuestionList} />
                  <Route path=":id" component={TrQuestionForm} />
                </Route>
                <Route path=":trID/categories" component={TrCategories} />
            </Route>
          </Route>
        </Route>
      </Router>
    </IntlProvider>
  </BackgroundSyncUIContextProvider>
)

let mapStateToProps = (state) => {
  let response = getResponse(state);
  let trIDForResponse = (response && response.userEdits) ? response.userEdits.trIDForResponse : -1;
  return{
    trIDForResponse: trIDForResponse
   }
 };

export default connect(mapStateToProps)(Routes);
